var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-dd550b242a3b6b8a5a6248c8d85caec3.svg#icon-logedin-user-icon-71ed4';
                    var viewUrl = 'svg-sprite-dd550b242a3b6b8a5a6248c8d85caec3.svg#view-icon-logedin-user-icon-71ed4';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };